import { createRouter, createWebHistory } from 'vue-router'

// 路由懒加载
const Index = () => import('../components/Index.vue')

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '公司官网 - 山东聚远医疗设备有限公司'
    }
  },
  {
    path: '/api/assess',
    component: () => import('@/view/api/assess'),
    hidden: true
  }
  // 移除NotFound路由配置
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 滚动行为：实现锚点平滑滚动
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  }
})

// 全局路由守卫：设置页面标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '公司官网';
  next();
})

export default router
